import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoClose24 } from '@onefootprint/icons';
import { IconButton, useConfirmationDialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { NavigationHeaderCloseButtonProps } from '../../types';
type NavigationCloseButtonProps = Omit<NavigationHeaderCloseButtonProps, 'variant'> & {
  onClose?: () => void;
  color?: Color;
};
const NavigationCloseButton = t0 => {
  const $ = _c(11);
  const {
    onClose,
    confirmClose,
    color
  } = t0;
  const confirmationDialog = useConfirmationDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "shell.global.components.confirmation-dialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== confirmClose || $[2] !== confirmationDialog || $[3] !== onClose || $[4] !== t) {
    t2 = () => {
      if (!confirmClose) {
        onClose?.();
        return;
      }
      confirmationDialog.open({
        title: t(_temp),
        description: t(_temp2),
        primaryButton: {
          label: t(_temp3),
          onClick: onClose
        },
        secondaryButton: {
          label: t(_temp4)
        }
      });
    };
    $[1] = confirmClose;
    $[2] = confirmationDialog;
    $[3] = onClose;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleClick = t2;
  let t3;
  if ($[6] !== color) {
    t3 = props => <IcoClose24 {...props} color={color ?? "primary"} />;
    $[6] = color;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleClick || $[9] !== t3) {
    t4 = <IconButton aria-label="Close" onClick={handleClick} icon={t3} />;
    $[8] = handleClick;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default NavigationCloseButton;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.confirm;
}
function _temp4($_2) {
  return $_2.cancel;
}